import React, { useState, useEffect } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import logo from '../../assets/oyecreators-logo.svg';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { Drawer } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';
import CampaignIcon from '@mui/icons-material/Campaign';
import CreditCardIcon from '@mui/icons-material/CreditCard';
// import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
// import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
// import AnalyticsIcon from '@mui/icons-material/Analytics';
import CheckroomIcon from '@mui/icons-material/Checkroom';
// import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import ArticleIcon from '@mui/icons-material/Article';
import MenuBookIcon from '@mui/icons-material/MenuBook';
// import SchoolIcon from '@mui/icons-material/School';
// import EventIcon from '@mui/icons-material/Event';
// import HelpCenterIcon from '@mui/icons-material/HelpCenter';
// import ForumIcon from '@mui/icons-material/Forum';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import EmailIcon from '@mui/icons-material/Email';
import { getConfig } from './env-config';

// --- Configuration for Mega Menu ---
const MEGA_MENU_ITEMS = [
    {
        label: 'Product',
        type: 'dropdown',
        columns: [
            {
                title: 'OYE CREATORS PLATFORM',
                items: [
                    { name: 'Discover Creators', desc: '200M+ database with 35+ filters', icon: <SearchIcon fontSize="small" />, color: 'blue', path: '/product/discover-creators' },
                    { name: 'Recruit Influencers', desc: 'Advanced creator search tactics', icon: <GroupAddIcon fontSize="small" />, color: 'indigo', path: '/product/recruit-influencers' },
                    { name: 'Manage Campaigns', desc: 'End-to-end campaign workflow', icon: <CampaignIcon fontSize="small" />, color: 'purple', path: '/product/manage-campaigns' },
                    { name: 'Analyze Influencers', desc: 'Audience, performance & fraud insights', icon: <TrendingUpIcon fontSize="small" />, color: 'pink', path: '/product/analyze-influencers' },
                    { name: 'Reach out to Creators', desc: 'Creator outreach and messaging', icon: <EmailIcon fontSize="small" />, color: 'rose', path: '/product/creator-outreach' },
                    { name: 'Payments', desc: 'Streamline payments & compliance', icon: <CreditCardIcon fontSize="small" />, color: 'green', path: '/product/creator-payments' },
                ]
            },
            // {
            //     title: 'MORE FEATURES',
            //     items: [
            //         { name: 'Media Monitor', desc: 'Track mentions, campaigns & trends', icon: <MonitorHeartIcon fontSize="small" />, color: 'teal', path: '/product/media-monitor' },
            //         { name: 'Media Plans', desc: 'Create presentation-ready plans', icon: <ArticleIcon fontSize="small" />, color: 'cyan', path: '/product/media-plans' },
            //         { name: 'Media Analytics', desc: 'Monitor influencer sales', icon: <AnalyticsIcon fontSize="small" />, color: 'orange', path: '/product/media-analytics' },
            //     ]
            // }
        ]
    },
    {
        label: 'Customers',
        type: 'dropdown',
        columns: [
            {
                title: 'INDUSTRIES',
                items: [
                    { name: 'All Industries', desc: 'Solutions for every sector', icon: <ArticleIcon fontSize="small" />, color: 'blue', path: '/solutions/industries' },
                    // { name: 'E-Commerce', desc: 'Drive sales with UGC', icon: <ShoppingCartIcon fontSize="small" />, color: 'orange' },
                    { name: 'Apparel & Fashion', desc: 'Trendsetting campaigns', icon: <CheckroomIcon fontSize="small" />, color: 'pink', path: '/solutions/fashion' },
                    // { name: 'Gaming', desc: 'Reach engaged audiences', icon: <SportsEsportsIcon fontSize="small" />, color: 'violet' },
                ]
            },
            {
                title: 'SUCCESS STORIES',
                items: [
                    { name: 'Case Studies', desc: 'See how brands grow', icon: <MenuBookIcon fontSize="small" />,path: '/blog', color: 'blue' },
                    // { name: 'Testimonials', desc: 'What clients say', icon: <ForumIcon fontSize="small" />, color: 'teal' },
                ]
            }
        ]
    },
    {
        label: 'Resources',
        type: 'dropdown',
        columns: [
            {
                title: 'LEARN',
                items: [
                    { name: 'Blog', desc: 'Influencer marketing tips', icon: <ArticleIcon fontSize="small" />, path: '/blog', color: 'indigo' },
                    // { name: 'Guides & Reports', desc: 'In-depth research', icon: <MenuBookIcon fontSize="small" />, color: 'blue' },
                ]
            },
            // {
            //     title: 'SUPPORT',
            //     items: [
            //         { name: 'Help Center', desc: 'Platform tutorials', icon: <HelpCenterIcon fontSize="small" />, color: 'cyan' },
            //         { name: 'Events', desc: 'Webinars and meetups', icon: <EventIcon fontSize="small" />, color: 'orange' },
            //         { name: 'Creator Academy', desc: 'Learn to grow', icon: <SchoolIcon fontSize="small" />, color: 'green' },
            //     ]
            // }
        ]
    },
    { label: 'Pricing', type: 'link', path: '/pricing-page' },
    { label: 'Get a Demo', type: 'link', path: '/demo', isSpecial: true } // Highlighted link
];

// Helper to get color classes
const getColorClasses = (color) => {
    const colors = {
        blue: 'bg-blue-50 text-blue-600 group-hover/item:text-blue-700',
        indigo: 'bg-indigo-50 text-indigo-600 group-hover/item:text-indigo-700',
        purple: 'bg-purple-50 text-purple-600 group-hover/item:text-purple-700',
        pink: 'bg-pink-50 text-pink-600 group-hover/item:text-pink-700',
        rose: 'bg-rose-50 text-rose-600 group-hover/item:text-rose-700',
        green: 'bg-emerald-50 text-emerald-600 group-hover/item:text-emerald-700',
        teal: 'bg-teal-50 text-teal-600 group-hover/item:text-teal-700',
        cyan: 'bg-cyan-50 text-cyan-600 group-hover/item:text-cyan-700',
        orange: 'bg-orange-50 text-orange-600 group-hover/item:text-orange-700',
        violet: 'bg-violet-50 text-violet-600 group-hover/item:text-violet-700',
    };
    return colors[color] || 'bg-gray-50 text-gray-600';
};

const WebsiteNavbar = ({ handleDrawerToggle, mobileOpen, setMobileOpen }) => {
    const { ecWebsiteUrl } = getConfig();
    const navigate = useNavigate();
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);

    // Detect scroll for dynamic navbar styling
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 20);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const theme = createTheme({
        palette: {
            primary: {
                main: '#E91E63',
            },
        },
    });

    const isActive = (path) => location.pathname === path;
    const drawerWidth = 280;

    const drawer = (
        <Box onClick={() => setMobileOpen(false)} sx={{ height: '100%', display: 'flex', flexDirection: 'column', bgcolor: 'white' }}>
            <div className='p-6 flex flex-col items-center border-b border-gray-100'>
                <img className="w-32 h-auto mb-4" src={logo} alt="Oye Creators" />
            </div>
            <div className='flex-1 py-4 overflow-y-auto'>
                <List>
                    {MEGA_MENU_ITEMS.map((item) => (
                        <div key={item.label}>
                            {item.type === 'link' ? (
                                <ListItem disablePadding>
                                    <ListItemButton onClick={() => navigate(item.path)} sx={{ py: 2, px: 4 }}>
                                        <ListItemText
                                            primary={item.label}
                                            primaryTypographyProps={{ className: 'font-sans font-bold text-gray-700' }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            ) : (
                                <>
                                    <ListItem sx={{ py: 1, px: 4 }}>
                                        <ListItemText
                                            primary={item.label}
                                            primaryTypographyProps={{ className: 'font-sans font-bold text-gray-400 text-sm uppercase tracking-wider' }}
                                        />
                                    </ListItem>
                                    {item.columns.map((col, idx) => (
                                        <div key={idx}>
                                            {col.items.map((subItem) => (
                                                <ListItemButton key={subItem.name} sx={{ py: 1.5, px: 6 }} onClick={() => subItem.path && navigate(subItem.path)}>
                                                    <span className="mr-3">{subItem.icon}</span>
                                                    <ListItemText
                                                        primary={subItem.name}
                                                        primaryTypographyProps={{ className: 'font-sans font-medium text-gray-700' }}
                                                    />
                                                </ListItemButton>
                                            ))}
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    ))}
                </List>
            </div>
            <div className="p-2 space-y-1 border-t border-gray-100">
                <Link to="/creators" className="block w-full py-3 px-4 text-left border border-gray-300 text-gray-700 rounded-lg font-bold font-sans hover:bg-gray-50 transition-colors">
                    For Creators
                </Link>
                <div className="pt-4 pl-4 text-left text-xs font-bold text-gray-400 uppercase tracking-wider">For Business</div>
                <div className="flex items-center space-x-3">
                    <a href={ecWebsiteUrl + "login"} target="_blank" rel="noopener noreferrer"
                        className="px-5 py-2.5 rounded-lg text-gray-700 font-bold font-sans text-sm hover:text-primary-600 hover:bg-gray-50 transition-all duration-300"
                    >
                        Login
                    </a>
                    <a href={ecWebsiteUrl + "signup"} target="_blank" rel="noopener noreferrer"
                        className="px-6 py-2.5 rounded-lg bg-primary-500 text-white font-bold font-sans text-sm hover:bg-primary-400 shadow-md hover:shadow-lg transition-all duration-300"
                    >
                        Try for Free
                    </a>
                </div>
            </div>
        </Box>
    );

    return (
        <ThemeProvider theme={theme} >
            <AppBar
                position="fixed"
                elevation={scrolled ? 4 : 0}
                sx={{
                    backgroundColor: scrolled ? 'rgba(255, 255, 255, 0.95)' : '#ffffff',
                    backdropFilter: scrolled ? 'blur(12px)' : 'none',
                    borderBottom: '1px solid',
                    borderColor: scrolled ? 'rgba(0,0,0,0.05)' : '#e5e7eb',
                    boxShadow: scrolled ? '0 4px 6px -1px rgba(0, 0, 0, 0.05)' : 'none',
                    transition: 'all 0.3s ease',
                    height: { xs: '80px', md: '90px' },
                    justifyContent: 'center'
                }}
            >
                <div className="container mx-auto px-6 lg:px-12 max-w-7xl h-full flex items-center justify-between relative">
                    {/* Logo Section */}
                    <Link to="/" className="flex-shrink-0 z-20" aria-label="home">
                        <img className="w-32 md:w-36 h-auto" src={logo} alt="Oye Creators" />
                    </Link>

                    {/* Desktop Navigation - Mega Menu Trigger Area */}
                    <div className="hidden md:flex items-center h-full space-x-1 lg:space-x-4">
                        {MEGA_MENU_ITEMS.map((item) => (
                            <div
                                key={item.label}
                                className="h-full flex items-center px-4 relative group"
                                onMouseEnter={() => item.type === 'dropdown' && setActiveDropdown(item.label)}
                                onMouseLeave={() => setActiveDropdown(null)}
                            >
                                <div
                                    className={`
                                        cursor-pointer font-sans font-medium text-[15px] flex items-center gap-1 transition-colors duration-200
                                        ${(activeDropdown === item.label || isActive(item.path)) ? 'text-primary-500 font-bold' : 'text-gray-600 hover:text-gray-900'}
                                        ${item.isSpecial ? 'text-gray-900 font-black hover:text-primary-500' : ''}
                                    `}
                                    style={item.isSpecial ? { fontWeight: 900 } : undefined}
                                    onClick={() => item.type === 'link' && navigate(item.path)}
                                >
                                    {item.label}
                                    {item.type === 'dropdown' && (
                                        <KeyboardArrowDownIcon
                                            fontSize="small"
                                            className={`transition-transform duration-200 opacity-50 group-hover:opacity-100 ${activeDropdown === item.label ? 'rotate-180' : ''}`}
                                        />
                                    )}
                                </div>

                                {/* Mega Menu Dropdown Panel */}
                                {item.type === 'dropdown' && (
                                    <div
                                        className={`
                                            fixed left-0 w-full top-[80px] md:top-[90px] bg-white shadow-xl border-t border-gray-100 overflow-hidden
                                            transition-all duration-300 origin-top z-50
                                            ${activeDropdown === item.label ? 'opacity-100 visible' : 'opacity-0 invisible'}
                                        `}
                                        style={{ display: activeDropdown === item.label ? 'block' : 'none' }}
                                    >
                                        <div className="container mx-auto max-w-7xl px-6 lg:px-12">
                                            <div className="flex gap-12" >
                                                {item.columns.map((col, idx) => (
                                                    <div key={idx} className={`${idx === 0 ? 'flex-[1.5] bg-gray-50/50 -ml-12 pl-12 py-8 pr-12' : 'flex-[1] py-8'}`}>
                                                        <h4 className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4 border-b border-gray-100 pb-2">
                                                            {col.title}
                                                        </h4>
                                                        <div className={`grid ${idx === 0 ? 'grid-cols-2' : 'grid-cols-1'} gap-x-6 gap-y-4`}>
                                                            {col.items.map((subItem) => (
                                                                <div
                                                                    key={subItem.name}
                                                                    onClick={() => subItem.path && navigate(subItem.path)}
                                                                    className="flex items-start p-2 rounded-lg hover:bg-white hover:shadow-sm cursor-pointer transition-all duration-200 group/item"
                                                                >
                                                                    <div className={`
                                                                        w-10 h-10 rounded-lg flex items-center justify-center mr-3 shrink-0 transition-colors
                                                                        ${getColorClasses(subItem.color)}
                                                                    `}>
                                                                        {subItem.icon}
                                                                    </div>
                                                                    <div>
                                                                        <div className="text-sm font-bold text-gray-800 group-hover/item:text-primary-600 transition-colors">
                                                                            {subItem.name}
                                                                        </div>
                                                                        <div className="text-xs text-gray-500 mt-0.5 leading-snug">
                                                                            {subItem.desc}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    {/* Right Side Actions: For Business (Login / Try for Free) */}
                    <div className="hidden md:flex items-center">
                        <Link
                            to="/creators"
                            className="text-gray-600 font-bold font-sans text-sm hover:text-primary-600 transition-colors mr-6"
                        >
                            For Creators
                        </Link>
                        <div className="h-8 w-[1px] bg-gray-200 mr-6"></div> {/* Vertical Divider */}

                        <div className="flex items-center gap-4">
                            <span className="text-xs font-bold text-gray-400 uppercase tracking-wider">For Business</span>
                            <div className="flex items-center space-x-3">
                                <a href={ecWebsiteUrl + "login"} target="_blank" rel="noopener noreferrer"
                                    className="px-5 py-2.5 rounded-lg text-gray-700 font-bold font-sans text-sm hover:text-primary-600 hover:bg-gray-50 transition-all duration-300"
                                >
                                    Login
                                </a>
                                <a href={ecWebsiteUrl + "signup"} target="_blank" rel="noopener noreferrer"
                                    className="px-6 py-2.5 rounded-lg bg-primary-500 text-white font-bold font-sans text-sm hover:bg-primary-400 shadow-md hover:shadow-lg transition-all duration-300"
                                >
                                    Try for Free
                                </a>
                            </div>
                        </div>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden">
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={handleDrawerToggle}
                            sx={{ color: 'text.primary' }}
                        >
                            <MenuIcon fontSize="large" />
                        </IconButton>
                    </div>
                </div>
            </AppBar>

            {/* Mobile Drawer */}
            <Drawer
                anchor="right"
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{ keepMounted: true }}
                sx={{
                    display: { xs: 'block', md: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
            >
                {drawer}
            </Drawer>
        </ThemeProvider>
    );
};

export default WebsiteNavbar;
